export default __webpack_public_path__ + "static/media/u_calender.788ad4bb.svg";